<template>
  <div>
    <v-row>
      <div class="center">
        <h1>Lista de recompras</h1>
      </div>
      <data-table
        :data="rows"
        :headers="[...headers]"
        :loading="false"
        :hide-edit="true"
        :hide-delete="true"
        :hide-data-table-bottom="false"
        :disable-set-query-string="true"
        :table-name="`ignored-${tableName}`"
        :custom-action="handleAddIgnoredAgain"
      />
    </v-row>
    <v-divider class="space-mg" />
    <repurchase-list-loans-new />
  </div>
</template>

<script>
import DataTable from 'Support/components/data-table/DataTable.vue';
import notificationMixin from 'Support/mixins/notification-mixin';
import pageableMixin from 'Support/mixins/pageable-mixin';
import DataTableCurrencyColumnVue from 'Support/components/data-table/DataTableColumns/DataTableCurrencyColumn.vue';
import DataTableDateColumnVue from 'Support/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import routerMixin from 'Support/mixins/router-mixin';
import crudMixin from 'Support/mixins/crud-mixim';
import RepurchaseLoteRequest from 'Domain/financial/RepurchaseLoteRequest';
import CrudListVue from 'Support/components/crud/CrudList.vue';
import SgvInjectionSituationColumn from './SgvInjectionSituationColumn.vue';
import RepurchaseListLoansNew from './RepurchaseListLoansNew.vue';

export default {
  name: 'RepurchaseListLoans',
  components: { DataTable, RepurchaseListLoansNew },
  extends: CrudListVue,
  mixins: [notificationMixin, pageableMixin, routerMixin, crudMixin],
  data: () => ({
    requestClass: RepurchaseLoteRequest,
    hideEdit: true,
    hideDelete: true,
    headers: [
      {
        text: 'NSU Tendência',
        value: 'nsuTendencia',
      },
      {
        text: 'COD Prorrogação',
        value: 'codCobrancaSgv',
      },
      {
        text: 'Situação prorrogação',
        value: 'prorrogacao.situacao',
      },
      {
        text: 'Valor prorrogação tecfin',
        value: 'prorrogacao.valorProrrogacaoTecfin',
        component: DataTableCurrencyColumnVue,
      },
      {
        text: 'Situação SGV',
        value: 'situacaoInjecaoProdutoSgv',
        component: SgvInjectionSituationColumn,
      },
      {
        text: 'Data contratação',
        value: 'prorrogacao.dataContratacao',
        component: DataTableDateColumnVue,
      },
      {
        text: 'Data vencimento',
        value: 'prorrogacao.dataVencimentoProrrogacaoTecfin',
        component: DataTableDateColumnVue,
      },
    ],
  }),
  methods: {
    makeRestRequest() {
      const params = this.transformSortQueryParams(this.getQueryParams());
      this.requestClass.list(params).then(({ data }) => {
        this.handleResponse(data.prorrogacoes, data.prorrogacoes.length);
      }).catch(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
.center{
  width: 100%;
  margin: 0 auto;
  padding: .8rem 0;
  display: flex;
  align-content: center;
  justify-content: center;
  text-align: center;
}

.center h1 {
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 29px;
  color: #2c2c2c;
}
</style>
